// @ts-nocheck
import React, { useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch } from "react-redux";
import { createCreditSegmentCode } from "../../../features/creditSegmentCode";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";

const AddCreditSegmentCode = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    key: "",
    value: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    // // // console.log(formData, "formData");
    dispatch(createCreditSegmentCode(formData))
      .then((resultAction) => {
        if (createCreditSegmentCode.rejected.match(resultAction)) {
          console.error(resultAction.payload || resultAction.error);
        } else {
          toast.success("Credit Segment Code created successfully.");
          navigate("/credit-segments");
        }
      })
      .catch((err) => {
        console.error(err, "error");
        toast.error("Failed to create Credit Segment Code.");
      });
  };

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />
      <SoftBox sx={{
          padding: "15px",
          backgroundColor: "#fff",
          boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
        }}>
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Add Credit Segment Code
          </SoftTypography>
        </SoftBox>
        <SoftBox component="form" role="form">
          {/* Key Input */}
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <SoftBox
              sx={{
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Key
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="text"
                name="key"
                placeholder="Enter the key"
                value={formData.key}
                onChange={handleChange}
              />
            </SoftBox>
            <SoftBox
              sx={{
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Value
                </SoftTypography>
              </SoftBox>
              <SoftInput
                type="text"
                name="value"
                placeholder="Enter the value"
                value={formData.value}
                onChange={handleChange}
              />
            </SoftBox>
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton
              variant="gradient"
              color="final"
              fullWidth
              onClick={handleSubmit}
            >
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddCreditSegmentCode;
